import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useState, useEffect, useCallback, useRef } from "react";
import { tokenDecode } from "../../../utils/helper";
import styles from "./navbar.module.css"
import bars from "../../../icons/MenuBar.png"
import { useLocation } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { BsGraphUp } from "react-icons/bs";

const Navbar = (props) => {
    const history = useHistory();
    const logoutExecutedRef = useRef(false);
    const logoutTimerRef = useRef(null);
    const dropdownRef = useRef(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const location = useLocation()
    // console.log("location---->", location)
    const token = sessionStorage.getItem("us_st_d");
    const decoded = tokenDecode();
    const { data } = decoded;
    const { user } = data;

    const logouthandler = useCallback(() => {
        sessionStorage.removeItem('us_st_d');
    }, []);

    const handleLogout = useCallback(() => {
        if (!logoutExecutedRef.current) {
            logoutExecutedRef.current = true;
            logouthandler();
            history.push('/');
        }
    }, [history, logouthandler]);

    useEffect(() => {
        const decoded = token && tokenDecode(token);
        const expirationTime = decoded?.exp * 1000;
        // const expirationDateTime = new Date(decoded.exp * 1000);
        // console.log('Token expired on:', expirationDateTime);
        if (expirationTime) {
            const delay = expirationTime - Date.now();
            logoutTimerRef.current = setTimeout(handleLogout, delay);
        } else {
            logouthandler();
        }

        return () => {
            clearTimeout(logoutTimerRef.current);
        };
    }, [token, handleLogout, logouthandler, history]);

    const [heading, setHeading] = useState({
        name: "Order Fulfillment",
        icon: "",
    })
    function getHeading(route) {
        if (route === "/addseller") {
            setHeading((prev) => { return { ...prev, name: "Register seller" } })
        }
        if (route === "/dashboard") {
            setHeading((prev) => { return { ...prev, name: "Overview" } })
        }
        if (route === "/warehouse") {
            setHeading((prev) => { return { ...prev, name: "Warehouses" } })
        }
        if (route === "/bidding") {
            setHeading((prev) => { return { ...prev, name: "All Biddings" } })
        }
        if (route === "/findproduct") {
            setHeading((prev) => { return { ...prev, name: "Find Product" } })
        }
        if (route === "/addwarehouse") {
            setHeading((prev) => { return { ...prev, name: "Add warehouse" } })
        }
        if (route === "/addvariants") {
            setHeading((prev) => { return { ...prev, name: "Add variants" } })
        }
        if (route === "/variantslist") {
            setHeading((prev) => { return { ...prev, name: "Variants List" } })
        }
        if (route === "/warehousefulfillment") {
            setHeading((prev) => { return { ...prev, name: "Warehouse fulfillment" } })
        }
        if (route === "/createproduct") {
            setHeading((prev) => { return { ...prev, name: "Add product" } })
        }
        if (route === "/instorecatalog") {
            setHeading((prev) => { return { ...prev, name: "All products" } })
        }
        if (route === "/newcategory") {
            setHeading((prev) => { return { ...prev, name: "Categories" } })
        }
         if (route === "/subcategory") {
            setHeading((prev) => { return { ...prev, name: "Sub Categories" } })
        }
        if (route === "/brand" || route === "/producttype" ) {
            setHeading((prev) => { return { ...prev, name: "Brands" } })
        }
        if (route === "/producttypelist" || route === "/producttype" || route.startsWith("/producttype/")) {
            setHeading((prev) => { return { ...prev, name: "Product Types" } })
        }
        if (route === "/productlist") {
            setHeading((prev) => { return { ...prev, name: "Products" } })
        }
        if (route === "/customerrder") {
            setHeading((prev) => { return { ...prev, name: "Customer Order List" } })
        }
        if (route === "/logrejection") {
            setHeading((prev) => { return { ...prev, name: "Catalog Rejection" } })
        }
        if (route === "/masterproductlist") {
            setHeading((prev) => { return { ...prev, name: "Master Product List" } })
        }
        if (route === "/orderlist") {
            setHeading((prev) => { return { ...prev, name: "Order List" } })
        }
        if (route === "/issues") {
            setHeading((prev) => { return { ...prev, name: "Ticket List" } })
        }
        if (route === "/raiseissue") {
            setHeading((prev) => { return { ...prev, name: "Raise an Issue" } })
        }
        if (route === "/supportlist") {
            setHeading((prev) => { return { ...prev, name: "Support List" } })
        }
        if (route === "/grievancesettings") {
            setHeading((prev) => { return { ...prev, name: "Grievance Settings" } })
        }
        if (route === "/roles") {
            setHeading((prev) => { return { ...prev, name: "Roles" } })
        }
        if (route === "/sellerlist") {
            setHeading((prev) => { return { ...prev, name: "Seller List" } })
        }
        if (route.startsWith("/updateseller/")) {
            setHeading((prev) => { return { ...prev, name: "Update Seller" } })
        }
        if (route === "/tax") {
            setHeading((prev) => { return { ...prev, name: "Tax" } })
        }
        if (route === "/warehouselist") {
            setHeading((prev) => { return { ...prev, name: "Warehouse" } })
        }
        if (route === "/policytemplatelist") {
            setHeading((prev) => { return { ...prev, name: "Policy Template" } })
        }
        if (route === "/policytemplate") {
            setHeading((prev) => { return { ...prev, name: "Add Policy Template" } })
        }
        if (route.startsWith("/policytemplate/")) {
            setHeading((prev) => { return { ...prev, name: "Update Policy Template" } })
        }
        if (route === "/foslist") {
            setHeading((prev) => { return { ...prev, name: "FOS" } })
        }
        if (route === "/fos") {
            setHeading((prev) => { return { ...prev, name: "Add FOS" } })
        }
        if (route.startsWith("/fos/")) {
            setHeading((prev) => { return { ...prev, name: "Update FOS" } })
        }
        if (route === "/riderdeliveries") {
            setHeading((prev) => { return { ...prev, name: "All Rider Deliveries" } })
        }
        if (route === "/channelmarginlist") {
            setHeading((prev) => { return { ...prev, name: "Channel Margin List" } })
        }
        if (route === "/mcrbrands") {
            setHeading((prev) => { return { ...prev, name: "MCR Brands" } })
        }
        if (route === "/master-catalogue") {
            setHeading((prev) => { return { ...prev, name: "Master Catalogue" } })
        }
        if (route === "/addrider") {
            setHeading((prev) => { return { ...prev, name: "Add Rider" } })
        }
        if (route === "/riderlist") {
            setHeading((prev) => { return { ...prev, name: "Rider List" } })
        }
        if (route.startsWith("/updateuser/")) {
            setHeading((prev) => { return { ...prev, name: "Update user" } })
        }
        if (route === "/completeOrder") {
            setHeading((prev) => { return { ...prev, name: "Delivered Orders" } })
        }
        if (route === "/returnorders") {
            setHeading((prev) => { return { ...prev, name: "Return Order List" } })
        }
        if (route === "/cancelOrderlist") {
            setHeading((prev) => { return { ...prev, name: "Cancel Order List" } })
        }
        if (route === "/userlist") {
            setHeading((prev) => { return { ...prev, name: "User List" } })
        }
        if (route === "/adduser") {
            setHeading((prev) => { return { ...prev, name: "Add a new user" } })
        }
        if (route === "/loglist") {
            setHeading((prev) => { return { ...prev, name: "Logs" } })
        }
        if (route === "/unsettledtransactions") {
            setHeading((prev) => { return { ...prev, name: "Unsettled Transactions List" } })
        }
        if (route === "/sellerDetails") {
            setHeading((prev) => { return { ...prev, name: "Seller Details" } })
        }
        if (route === "/transaction") {
            setHeading((prev) => { return { ...prev, name: "Settled Transactions List" } })
        }
        if (route === "/productcatalog") {
            setHeading((prev) => { return { ...prev, name: "Master Catalog" } })
        }
        if (route === "/customerorder") {
            setHeading((prev) => { return { ...prev, name: "Customer Order List" } })
        }
        if (route === "/updatepassword") {
            setHeading((prev) => { return { ...prev, name: "Update Password" } })
        }
        if (route === "/settings") {
            setHeading((prev) => { return { ...prev, name: "Connect Your Online Store" } })
        }

        if (route.startsWith("/warehousefulfillment")) {
            setHeading((prev) => ({
                ...prev,
                name: "Warehouses fulfillments"
            }))
        }
        if (route.startsWith("/addwarehouse")) {
            setHeading((prev) => ({
                ...prev,
                name: "Warehouses"
            }))
        }
        if (route.startsWith("/warehouseserviceability")) {
            setHeading((prev) => ({
                ...prev,
                name: "Warehouse serviceability"
            }))
        }
    }
    useEffect(() => {
        getHeading(location.pathname)
    }, [location.pathname])

    useEffect(() => {
        const closeDropdown = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        const closeOnEscape = (event) => {
            if (event.key === "Escape") setIsDropdownOpen(false);
        };

        document.addEventListener("mousedown", closeDropdown);
        document.addEventListener("keydown", closeOnEscape);
        return () => {
            document.removeEventListener("mousedown", closeDropdown);
            document.removeEventListener("keydown", closeOnEscape);
        };
    }, []);


    return (
        <>
            <nav className={`navbar navbar-expand navbar-light  topbar  static-top  ${styles.mobile_navbar}`}>
                <button id="sidebarToggleTop" className={`btn btn-link rounded-circle mr-3 ${styles.burgerButton}`} onClick={() => props.Showmenu()}>
                    <img src={bars} alt="" style={{ height: "70%" }} />
                </button>

                <div className="d-flex justify-content-between w-100 align-items-center">
                    <div
                        className="mt-2 pl-3"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                        }}
                    >
                        <div
                            style={{
                                width: "30px",
                                height: "30px",
                                background: "#F3EFFD",
                                borderRadius: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <BsGraphUp
                                style={{
                                    color: "#7C5CFC",
                                    fontSize: "15px",
                                }}
                            />
                        </div>

                        <span
                            style={{
                                fontSize: "15px",
                                color: "#000",
                                fontWeight: "600",
                            }}
                        >
                            {heading?.name}
                        </span>
                    </div>

                    <ul className="navbar-nav">
                        <li ref={dropdownRef} className={`nav-item dropdown no-arrow ${styles.plus}`}>
                            <button
                                type="button"
                                className="nav-link dropdown-toggle d-flex align-items-center"
                                id="userDropdown"
                                aria-haspopup="true"
                                aria-expanded={isDropdownOpen}
                                onClick={() => setIsDropdownOpen((isOpen) => !isOpen)}
                                style={{
                                    background: "#fff",
                                    border: "1px solid #E5E7EB",
                                    borderRadius: "25px",
                                    padding: "1px 5px",
                                    width: "140px",
                                    height: "39px",

                                    textDecoration: "none",
                                }}
                            >
                                {/* Avatar */}
                                <div
                                    style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        background: "linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%)",
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "700",
                                        fontSize: "18px",
                                        marginRight: "12px",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    {user?.name?.charAt(0)}
                                </div>

                                {/* User Details */}
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        flex: 1,
                                        lineHeight: "15px",
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "#1F2937",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                        }}
                                    >
                                        {user?.name}
                                    </span>

                                    <span
                                        style={{
                                            color: "#9CA3AF",
                                            fontSize: "11px",
                                        }}
                                    >
                                        Seller
                                    </span>
                                </div>

                                {/* Down Arrow */}
                                <i
                                    className="fa fa-angle-down"
                                    style={{
                                        color: "#9CA3AF",
                                        fontSize: "18px",
                                    }}
                                ></i>
                            </button>

                            {/* Dropdown Menu */}
                            <div
                                className={`dropdown-menu shadow p-0 ${styles.dropDownPosition} ${isDropdownOpen ? styles.dropdownOpen : styles.dropdownClosed}`}
                                aria-labelledby="userDropdown"
                                aria-hidden={!isDropdownOpen}
                            >
                                <div className={styles.doropdownnavmenu}>
                                    {user?.seller_id !== 1 && (
                                        <>
                                            <Link to="/warehouse?tab=shopdetails" className="dropdown-item">
                                                <i className="fas fa-home fa-sm fa-fw mr-2 text-gray-400"></i>
                                                Warehouse
                                            </Link>
                                            <div className="dropdown-divider"></div>
                                        </>
                                    )}

                                    {/* <div className="dropdown-divider"></div> */}

                                    {/* <Link to="/serviceability" className="dropdown-item">
                                        <i className="fa fa-globe fa-sm fa-fw mr-2 text-gray-400"></i>
                                        Serviceability
                                    </Link> */}

                                    <Link to="/updatepassword" className="dropdown-item">
                                        <i className="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                                        Update Password
                                    </Link>

                                    <div className="dropdown-divider"></div>

                                    <Link to="/sellerDetails" className="dropdown-item">
                                        <FaUser className="fa-fw mr-2 text-gray-400" />
                                        Seller Details
                                    </Link>

                                    <div className="dropdown-divider"></div>

                                    <Link
                                        to="#"
                                        onClick={logouthandler}
                                        className="dropdown-item"
                                    >
                                        <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                        Logout
                                    </Link>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

            </nav>
        </>
    )
}

export default Navbar;